export default{
  "Video Compressor": "Compressor de Vídeo",
  "HitPaw Online Video Compressor": "HitPaw Online Compressor de Vídeo",
  "Best video compressor tool to reduce video file size online without losing quality.": "A melhor ferramenta de compressor de vídeo para reduzir o tamanho de arquivo de vídeo online sem perder qualidade.",
  "Quality": "Qualidade",
  "Small Size": "Tamanho Pequeno ({{num}}%)",
  "High Quality": "Alta Qualidade ({{num}}%)",
  "Frame Rate": "Taxa de Quadros",
  "Resolution": "Resolução",
  "Keep Resolution": "Manter Resolução Original",
  "Format": "Formato",
  "Compress": "Comprimir",
  "Compressing": "Comprimindo",
  "Compress New": "Comprimir Novo",
  "xx% reduction in size!": "{{num}}% de redução no tamanho!",
  "Compressed successfully, your file is now xxMB.": "Comprimido com sucesso, o tamanho do seu arquivo agora é <p> {{originalSize}}MB</p> <p>{{compressSize}}MB</p>.",
  "Compression Failed": "Falha na compressão",
};